import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import ApplicationManagement from './ApplicationManagement';
import AdmissionForm from './AdmissionForm';
import InterviewSchedule from './InterviewSchedule';
import AdmissionStatus from './AdmissionStatus';
import EnrollStudent from './EnrollStudent';

interface AdmissionsModuleProps {
  domain: string;
  onBack: () => void;
}

const AdmissionsModule: React.FC<AdmissionsModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('applications');

  // Update active tab based on current route
  React.useEffect(() => {
    const path = location.pathname;
    if (path.includes('/new-application')) setActiveTab('new-application');
    else if (path.includes('/interviews')) setActiveTab('interviews');
    else if (path.includes('/enroll')) setActiveTab('enroll');
    else if (path.includes('/status')) setActiveTab('status');
    else setActiveTab('applications');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-person-plus-fill me-2"></i>
            Admissions Management
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'applications' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/admissions')}
              >
                <i className="bi bi-list-ul me-2"></i>Applications
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'new-application' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/admissions/new-application')}
              >
                <i className="bi bi-file-earmark-plus me-2"></i>New Application
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'interviews' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/admissions/interviews')}
              >
                <i className="bi bi-calendar-event me-2"></i>Interview Schedule
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'enroll' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/admissions/enroll')}
              >
                <i className="bi bi-person-plus-fill me-2"></i>Enroll Students
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'status' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/admissions/status')}
              >
                <i className="bi bi-check-circle me-2"></i>Admission Status
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<ApplicationManagement domain={domain} />} />
          <Route path="new-application" element={<AdmissionForm domain={domain} />} />
          <Route path="interviews" element={<InterviewSchedule domain={domain} />} />
          <Route path="enroll" element={<EnrollStudent domain={domain} />} />
          <Route path="status" element={<AdmissionStatus domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdmissionsModule;
